import { EnabledFontsType } from 'types/BrandingColorSchema';

export const isEnableFontFieldType = (option:EnabledFontsType | unknown): option is EnabledFontsType => (
  (<EnabledFontsType>option).type !== undefined
);

export default undefined;